import { z } from "@/zod";

export const projectId = z.string().length(26);
